import React from "react";
import { Redirect, useParams } from "react-router-dom";
import Cookies from "universal-cookie";

import config from "config";

const cookies = new Cookies();

const AcceptInvite = () => {
  const params = useParams<{ invitationId?: string }>();

  /**
   * Sets a cookie that tells us that the user is using Auth0 before redirecting
   * to the homepage, which then sends them to the Auth0 universal login page
   */
  cookies.set(`isAuth0User-${config.ENVIRONMENT}`, true, {
    domain: ".codat.io",
    path: "/",
  });

  return <Redirect to={`/?invitationId=${params.invitationId}`} />;
};

export default AcceptInvite;
